module.exports = __webpack_public_path__ + "static/media/club-2.97efc99d.png";